module.exports = __webpack_public_path__ + "img/people-carry-solid.27b63ed4.svg";